import { render, staticRenderFns } from "./Tail.vue?vue&type=template&id=cbcbeb8a&"
import script from "./Tail.vue?vue&type=script&lang=js&"
export * from "./Tail.vue?vue&type=script&lang=js&"
import style0 from "./Tail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports